export const ALLOWED_DOC_FILES = [
    'pdf',
    'txt',
    'md',
    'csv',
    'tsv',
    'doc',
    'dot',
    'docx',
    'xls',
    'xlsx',
    'ppt',
    'pptx',
    'odt',
    'ods',
    'odp',
    'epub',
    'zip',
    'rtf',
    'json',
    'yaml',
    'yml',
    'xml'
];
//# sourceMappingURL=docs.types.js.map